exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-treeselect__control{font-size:.875rem!important}.stocktransfers-table{font-size:9pt}.stocktransfers-table .stocktransfers-table-style-actions{min-width:120px}.stocktransfers-table .stocktransfers-table-style-actions .actions-icons{text-align:center;white-space:nowrap}.stocktransfers-table .stocktransfers-table-style-phone{min-width:105px}.stocktransfers-table .stocktransfers-table-style-th-datetime{min-width:110px}.stocktransfers-table .stocktransfers-table-style-td-datetime{text-align:center}", ""]);

// exports
